export default __webpack_public_path__ + "static/media/Nexia.7b6392e9.jpg";